/**
 * Inbox thread toolbar language (INBOX-HD, 2026-09-02) — one pill size for
 * every control in the thread header, so Qualify / Create dispatch / Assign /
 * Done / ⋯ read as a single row instead of five different buttons.
 * h-8 · rounded-full · 12.5px semibold — the shell's secondary button size.
 */
export const TOOL_BTN =
  "inline-flex h-8 items-center gap-1.5 rounded-full border border-hairline bg-white px-3 text-[12.5px] font-semibold text-slate-700 transition-colors duration-150 hover:bg-slate-50 hover:border-slate-300 disabled:opacity-60";

export const TOOL_BTN_PRIMARY =
  "inline-flex h-8 items-center gap-1.5 rounded-full bg-brand-700 px-3 text-[12.5px] font-semibold text-white shadow-e1 transition-colors duration-150 hover:bg-brand-800 disabled:opacity-60";

/** Icon-only variant (the ⋯ menu). */
export const TOOL_BTN_ICON =
  "inline-flex h-8 w-8 items-center justify-center rounded-full border border-hairline bg-white text-slate-500 transition-colors duration-150 hover:bg-slate-50 hover:text-slate-900 hover:border-slate-300";
